// export { default as StyleSheet } from './stylesheet';
// export * from './stylesheet';
export { injectCss as inject, flush, injectGlobalCss } from './utils/inject';
//# sourceMappingURL=index.js.map